// import { HttpStatusCode } from "axios"

// export const BASE_URL = "http://127.0.0.1:8000";


import axios from "axios";
import { HttpStatusCode } from "axios"
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

// export const BASE_URL = "http://0.0.0.0:8000/";

export const BASE_URL = "https://comski-dev-api.transpoze.ai/";
// export const BASE_URL = "https://comski-loadbalancer.transpoze.ai/";
// export const BASE_URL = "http://13.203.78.139/";
export const endpoints = {
   INDEX: "api/upload_videos/",
   SIGNIN:  "api/login/",
   SIGNUP: "api/register/",
   LOGIN: "/auth/token/",  // Your login endpoint
   REFRESH: "/auth/token/refresh/",  // Refresh token endpoint
   VERIFY: "/auth/token/verify/",  // Verify token endpoint (if available)
   USER_DETAILS: "/auth/user/",   
   GOOGLE_LOGIN: "auth/google",
   GOOGLE_URL:'auth/google/login/'
}

// Create an axios instance
const apiClient = axios.create({
  baseURL: BASE_URL,
});

export default BASE_URL;


// Function to refresh the access token
const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) throw new Error("No refresh token available");

    const response = await axios.post(`${BASE_URL}${endpoints.REFRESH}`, {
      refresh: refreshToken,
    });

    const newAccessToken = response.data.access;
    localStorage.setItem("access_token", newAccessToken);
    return newAccessToken;
  } catch (error) {
    console.error("Error refreshing token", error);
    localStorage.clear();
    window.location.href = "/"; // Redirect to login if refresh fails
  }
};

// Request interceptor (adds Authorization header)
apiClient.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor (refresh token logic)
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const newToken = await refreshAccessToken();

      if (newToken) {
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return apiClient(originalRequest); // Retry request with new token
      }
    }

    return Promise.reject(error);
  }
);


 // Function to save the answer
export const saveAnswer = async (question, answer) => {
  try {
    const response = await apiClient.post('/api/save_answer/', { question, answer });
    return response.data;
  } catch (error) {
    handleUnauthorizedError(error);
    throw error;
  }
};

export const getPresignedUrl = async (mode) => {
  try {
    let requestUrl = "/api/generate-presigned-url/";

    // Add mode to the URL as a query string if it exists
    if (mode) {
      requestUrl = `/api/generate-presigned-url?mode=${mode}`;
    }
    const response = await apiClient.get(requestUrl);
    console.log('presigned url response ' , response);
    return response.data;
  } catch (error) {
    console.error("Error fetching pre-signed URL", error);
    throw error;
  }
};


export const uploadVideo = async (formData) => { 
  try {
    const response = await apiClient.post('/api/upload_videos/', formData);
    return response.data;
  } catch (error) {
    handleUnauthorizedError(error);
    console.error("API Upload Error:", error);
    throw error;
  }
};


export const getStatus = async (videoId) => {
  try {
    const response = await apiClient.get(`/api/video_status/${videoId}/`);
    return response.data;
  } catch (error) {
    handleUnauthorizedError(error);
    throw error;
  }
};

export const getProgress = async (videoId) => {
  try {
    const response = await apiClient.get(`/api/get_progress/${videoId}/`);
    return response.data;
  } catch (error) {
    handleUnauthorizedError(error);
    throw error;
  }
}

export const getComscore = async (videoId) => {
  try {
    const response = await apiClient.get(`/api/detail/${videoId}/`);
    const comscoreData = response.data;  
    
    console.log("Comscore data:", comscoreData);
    return comscoreData;
  } catch (error) {
    console.error("Error fetching Comscore:", error);
    alert("Error fetching Comscore data.");
  }
};

export const getResult = async (videoId) => {
  try {
    const response = await apiClient.get(`/api/videos/${videoId}/`);
    const resultData = response.data;
    // console.log("Result data:", resultData);
    return resultData;
    } catch (error) {
      console.error("Error fetching result:", error);
      alert("Error fetching result data.");
    }
  };

export const getPDFData = async (videoId, setLoading) => {
  try {
    setLoading(true);
    const userId = localStorage.getItem('user_id');
    const response = await apiClient.get(`/api/get_pdf_data/${userId}/${videoId}/`);
    const fileUrl = response.data;

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.pdf"); // Custom filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  } catch (error) {
    console.error("Error fetching result:", error);
    alert("Error fetching result data.");
  } finally {
    setLoading(false);
  }
};


  export const saveResult = async (videoId) => {
    try {
      const response = await apiClient.post("/api/update_save_status/", {
        video_id: videoId, // Send video_id in request body
      });
      return response.data;
    } catch (error) {
      handleUnauthorizedError(error);
      throw error;
    }
  };
  
  // export const getMyResult = async (profileId) => {
  //   try {
  //     const response = await apiClient.get(`/api/videos/saved/${profileId}/`);
  //     return response.data;
  //   } catch (error) {
  //     handleUnauthorizedError(error);
  //     throw error;
  //   }
  // };
  
  export const getMyResult = async (profileId) => {
    try {
      const response = await apiClient.get(`/api/videos/profile/${profileId}/`);
      return response.data;
    } catch (error) {
      handleUnauthorizedError(error);
      throw error;
    }
  };

  //handle delete video
  export const deleteVideo = async (videoId) => {
    try {
      const response = await apiClient.delete(`/api/delete/${videoId}/`);
      return response.data;
    } catch (error) {
      handleUnauthorizedError(error);
      throw error;
    }
  };

  //handle delete video s3 path
  export const deleteS3Path = async (videoId) => {
    try {
      const response = await apiClient.post(`/api/video/${videoId}/delete-s3-path/`);
      return response.data;
    } catch (error) {
      handleUnauthorizedError(error);
      throw error;
    }
  };
  
  export const updateVideoName = async (videoId, newName) => {
    try {
      const response = await apiClient.put(`/api/update/${videoId}/`, { video_name: newName });
      return response.data;
    } catch (error) {
      handleUnauthorizedError(error);
      throw error;
    }
  };
  
// Handle Unauthorized Error (Expired or Invalid Token)
const handleUnauthorizedError = (error) => {
   if (error.response && error.response.status === 401) {
     // Redirect to login page if token is expired or invalid
     localStorage.clear();
     window.location.href = "/";
   } else {
     console.error("Error:", error);
   }
 };
 

 // Check if token is valid
const isTokenValid = (token) => {
  if (!token) return false;
  const decodedToken = jwtDecode(token);
  return decodedToken.exp * 1000 > Date.now();
};

// ProtectedRoute component
export const ProtectedRoute = () => {
  const accessToken = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");

  if (accessToken && isTokenValid(accessToken)) {
    return <Outlet />;
  } else if (refreshToken && isTokenValid(refreshToken)) {
    // Attempt to refresh the access token
    axios
      .post(`${BASE_URL}${endpoints.REFRESH}`, { refresh: refreshToken })
      .then((response) => {
        localStorage.setItem("access_token", response.data.access);
        window.location.reload();
      })
      .catch(() => {
        localStorage.clear();
        window.location.href = "/";
      });

    return null;
  } else {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }
};